import { CheckboxOptionType, Select, SelectProps } from 'antd';
import { BaseOptionType } from 'antd/es/select';
import classNames from 'classnames';
import { useCallback, useMemo } from 'react';

import { ReactComponent as ChevroneDownIcon } from '@Icons/additional/chevrone-down.svg';
import RenderOption from './component/RenderOption';
import RenderDropdown from './component/RenderDropdown';

import './select.module.css';
import RenderDropdownCheckbox from './component/RenderDropdownCheckbox';
import CustomTag from './component/CustomTag';

interface MSelectProps extends SelectProps {
  labeloption?: string;
  checkboxOptions?: boolean;
}

const MSelect: React.FC<MSelectProps> = (props) => {
  const {
    className,
    labeloption,
    options,
    checkboxOptions,
    onChange,
    value,
    ...restProps
  } = props;

  const renderOption = useCallback(
    (option: BaseOptionType) => <RenderOption option={option} />,
    []
  );

  const renderDropDown = useCallback(
    (menu: React.ReactElement) => (
      <RenderDropdown menu={menu} labelOption={labeloption || ''} />
    ),
    [labeloption]
  );

  const renderDropdownWithCheckbox = useCallback(
    () => (
      <RenderDropdownCheckbox
        labelOption={labeloption || ''}
        options={options as CheckboxOptionType[]}
        onChange={(checkedOptions) => {
          onChange?.(checkedOptions, {});
        }}
        checkedOptions={Array.isArray(value) ? value : undefined}
      />
    ),
    [labeloption, options, onChange, value]
  );

  const selectedOptionsValue = useMemo(() => {
    if (!checkboxOptions || !value?.length) {
      return {};
    }
    const output = { defaultValue: value };
    return output;
  }, [checkboxOptions, value]);

  return (
    <Select
      {...{ value, onChange, options, ...restProps }}
      dropdownStyle={{ borderRadius: '4px' }}
      dropdownRender={
        checkboxOptions ? renderDropdownWithCheckbox : renderDropDown
      }
      optionRender={renderOption}
      className={classNames('trojan-select', className)}
      suffixIcon={<ChevroneDownIcon />}
      {...selectedOptionsValue}
      {...(checkboxOptions && { mode: 'multiple' })}
      {...(checkboxOptions && { tagRender: CustomTag })}
    />
  );
};

export default MSelect;
